export const Role = {
  Admin: 'ROLE_ADMIN',
  User: 'ROLE_USER',
}
